import React from 'react'
import styled from '@emotion/styled'
import { FormattedMessage } from 'react-intl'

import Link from 'components/Links'

import ListArrowRight from 'common/icons/list-arrow-right'

const LinkContainer = styled(Link)`
margin-left: auto;
color: ${({ theme }) => theme.white};
text-decoration: none;
display: flex;
align-items: center;
`

const LinkContent = styled.span`
  margin-right: 10px;
`

const LinkTo = ({ nodeId }) => {
  return (
    <LinkContainer to={`/${nodeId}`}>
      <LinkContent>
        <FormattedMessage id='list-open-link' />
      </LinkContent>
      <ListArrowRight />
    </LinkContainer>
  )
}

export default LinkTo
